import { isNil, pick } from 'lodash-es'
import {
  getSummaryValue,
  formatModelValue,
  makeExpEstHeaders,
  getTitle,
  buildDisplayText,
  makeModelTable,
} from '../utils'

import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { mapUnitOrOriginal } from '@/components/combined-predict/components/CombinedPredictTable/utils/unitConversions'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, 'Half-life')

  const rows = (meta?.children ?? [])
    .map((child) => {
      const value = getPredictionDataBySource(item, child.id)
      if (isNil(value)) return null
      const unit = mapUnitOrOriginal(child?.unit)

      return [
        buildDisplayText({ mainText: child?.name, secondaryText: unit }),
        formatModelValue(value),
        item?.model?.notes ?? '',
      ]
    })
    .filter(Boolean)

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders({ experimental: null, references: null, extra: ['Notes'] }),
        rows: rows,
      },
    ],
    notes: item?.predicted?.model?.notes,
  }
}

const modelDescriptorsMapper = (item, meta) => {
  const model = item?.predicted?.model
  const modelTable = makeModelTable(pick(model, ['factors', 'logHalfLifeDays', 'halfLifeDays']))

  return {
    tables: [modelTable],
    notes: model?.notes,
  }
}

const bioHcWin = (items) => {
  const item = items?.find((item) => item.property === 'hydrocarbonBiodegradationRate')
  const meta = findEpiSuiteGroupById('hydrocarbonBiodegradationRate')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item, meta),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { bioHcWin }
